"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _config = require("@trs/config");
var _radio = require("../../radio");
var _helpers = require("./helpers");
var _PercentageToggler = _interopRequireDefault(require("./PercentageToggler.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var options = [{
  value: _helpers.SEARCHABLE_TYPES.NUMERIC_SIMPLE,
  ariaLabel: 'searchableTypeNumber',
  id: 'searchableTypeNumber',
  textAsIcon: _config.PERCENTAGE_TOGGLER_ICONS.NUMERIC,
  withNativeInput: false
}, {
  value: _helpers.SEARCHABLE_TYPES.NUMERIC_PERCENTAGE,
  ariaLabel: 'searchableTypePercentage',
  id: 'searchableTypePercentage',
  textAsIcon: _config.PERCENTAGE_TOGGLER_ICONS.PERCENTAGE,
  withNativeInput: false
}];
/* remove value from prop - simplify this component - */
var PercentageToggler = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PercentageToggler, _React$PureComponent);
  var _super = _createSuper(PercentageToggler);
  function PercentageToggler() {
    _classCallCheck(this, PercentageToggler);
    return _super.apply(this, arguments);
  }
  _createClass(PercentageToggler, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        type = _this$props.type,
        onTypeChange = _this$props.onTypeChange,
        percentageOnly = _this$props.percentageOnly,
        numericOnly = _this$props.numericOnly;
      var data = options;
      if (numericOnly) {
        data = [options[0]];
      } else if (percentageOnly) {
        data = [options[1]];
      }
      return /*#__PURE__*/_react["default"].createElement(_PercentageToggler["default"], {
        className: "searchable-percent-toggle"
      }, /*#__PURE__*/_react["default"].createElement(_radio.RadioGroup, {
        onChange: function onChange(ev) {
          return onTypeChange({
            type: (0, _utils.getEventValue)(ev)
          });
        },
        selectedValue: type,
        disabled: false,
        name: "searchableTypeRadios",
        options: data,
        errors: ""
      }));
    }
  }]);
  return PercentageToggler;
}(_react["default"].PureComponent);
PercentageToggler.defaultProps = {
  percentageOnly: false,
  numericOnly: false
};
PercentageToggler.propTypes = {
  /* Should we show only percentages? */
  percentageOnly: _propTypes["default"].bool,
  /* Should we show only numeric? */
  numericOnly: _propTypes["default"].bool,
  /* The searchable type, either numeric or percentage */
  type: _propTypes["default"].oneOf(['percentage', 'numeric']).isRequired,
  /* The formula change store action */
  onTypeChange: _propTypes["default"].func.isRequired
};
PercentageToggler.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PercentageToggler",
  "props": {
    "percentageOnly": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "numericOnly": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "type": {
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'percentage'",
          "computed": false
        }, {
          "value": "'numeric'",
          "computed": false
        }]
      },
      "required": true
    },
    "onTypeChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};
var _default = PercentageToggler;
exports["default"] = _default;